// extracted by mini-css-extract-plugin
module.exports = {"button":"g5epoQ","primary":"Oa0GvL","secondary":"_0hND2F","tertiary":"jMggho","sm":"ZFAAJA","md":"h2_Ys_"};